import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';

import { Heading } from '../Heading';
import { InfoCard } from '../InfoCard';

export interface TwinCreationContentProps {
  openNextTab: () => void;
}

const TwinCreationContent: React.FC<TwinCreationContentProps> = memo(
  ({ openNextTab }) => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const isMacos = searchParams.get('platform') === 'macos';

    return (
      <>
        <Heading title={t('twin.mainTitle')} />
        <div className="max-w-[544px] m-auto">
          <video
            autoPlay
            loop
            muted
            playsInline
            disablePictureInPicture
            className="w-full object-cover rounded-2xl aspect-video "
            src="https://mentordata-acazgce6cvdzgng9.z02.azurefd.net/marketing/twin-video-reduced.mp4"
          />
          <InfoCard
            className="mt-4"
            title={t('twin.whyCreate')}
            description={t('twin.whyCreateDesc')}
          />
          <InfoCard
            title={t('twin.officeHours')}
            description={t('twin.officeHoursDesc')}
          />
          <div className="flex gap-4 justify-center mt-4">
            <Link
              data-testid="do-this-later-link"
              className="btn btn-secondary sm:!grow-0 !grow"
              to={isMacos ? 'napster-companion://cloning-close' : '/'}>
              {t('twin.doThisLater')}
            </Link>
            <button
              data-testid="create-my-twin-btn"
              className="btn btn-primary sm:!grow-0 !grow"
              onClick={openNextTab}>
              {t('twin.createMyTwin')}
              <i className="fa-solid fa-arrow-right ml-2" />
            </button>
          </div>
          <p className="mt-2 text-center text-dark-neutral-200 text-xs">
            {t('twin.completionNote')}
          </p>
        </div>
      </>
    );
  },
);

export { TwinCreationContent };
